import { inject, Injectable } from '@angular/core';

import { LOGGER } from '../../tokens/express.tokens';
import { LogLevelEnum } from './log-level.enum';
import { Logger } from './logger.model';

export interface LoggerMessage {
  level: LogLevelEnum;
  message: string;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly logger: Logger = inject(LOGGER);

  send(messages: LoggerMessage[]): void {
    messages.forEach(m => this.write(LogLevelEnum[m.level], m.message, m.data));
  }

  log(level: LogLevelEnum, message: string, data?: any, error?: any): void {
    const meta: Record<string, any> = {
      ...(data ?? {}),
      ...(error
        ? {
            errorMessage: error.message,
            errorStack: error.stack,
            errorName: error.name,
          }
        : {}),
    };

    this.write(LogLevelEnum[level] as any, message, meta);
  }

  error(message: string, data?: any): void {
    this.write(LogLevelEnum.error, message, data);
  }
  warn(message: string, data?: any): void {
    this.write(LogLevelEnum.warn, message, data);
  }
  info(message: string, data?: any, req?: Request): void {
    this.write(LogLevelEnum.info, message, data);
  }
  debug(message: string, data?: any, req?: Request): void {
    this.write(LogLevelEnum.debug, message, data);
  }

  /* -------------------------------------------------------------------- */
  /*  Méthode centrale d’écriture                                         */
  /* -------------------------------------------------------------------- */

  private write(level: 'info' | 'warn' | 'error' | 'debug', message: string, meta: Record<string, unknown> | string | any = {}): void {
    const metaObject = typeof meta === 'string' ? { details: meta } : meta && typeof meta === 'object' ? meta : {};

    const payload: Record<string, unknown> = {
      level,
      message,
      ...metaObject,
    };

    this.logger.log(payload);
  }
}
